import styled, { keyframes, css } from 'styled-components';

const BallAnimation1 = keyframes`
    0% {
      transform: translate(-50%, 0%);
    }
    40% {
      transform: translate(-50%, -90px);
      width: 63%;
      padding-bottom: 63%;
    }
    50% {
      transform: translate(-50%, -100px);
      width: 63%;
      padding-bottom: 63%;
    }
    65% {
      transform: translate(-50%, -90px);
      width: 63%;
      padding-bottom: 63%;
    }
    75% {
      transform: translate(-50%, 0%);
      width: 63%;
      padding-bottom: 63%;
    }
    100% {
      transform: translate(-50%, 10px);
      width: 104%;
      padding-bottom: 31.5%;
    }
`;

const BallAnimation2 = keyframes`
    0% {
      transform: scale(0.9);
      opacity: 1;
    }
    50% {
      transform: scale(0.2);
      opacity: 0.3;
    }
    100% {
      transform: scale(0.9);
      opacity: 1;
    }`;

const Flex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 40px;
  min-width: 100%;
`;

const BallWrapper = styled.div(({ theme }) => {
  const { color } = theme;
  return css`
    position: relative;
    display: inline-block;
    float: left;
    width: 23%;
    height: 100%;
    margin: 0 4%;
    overflow: hidden;

    &::before {
      position: absolute;
      bottom: -1%;
      width: 100%;
      left: 0%;
      padding-bottom: 16%;
      border-radius: 50%;
      background: ${color.primary.regular};
      opacity: 1;
      animation-name: ${BallAnimation2};
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      z-index: 1;
      content: '';
    }

    &::after {
      position: absolute;
      width: 63%;
      padding-bottom: 63%;
      bottom: 0;
      left: 50%;
      border-radius: 50px;
      border: 1px solid ${color.primary.regular};
      transform: translate(-50%, 0%);
      transform-origin: center;
      z-index: 2;
      background-color: ${color.primary.regular};
      animation-name: ${BallAnimation1};
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      content: '';
    }

    &:nth-of-type(1)::before {
      animation-delay: 0s;
    }

    &:nth-of-type(1)::after {
      animation-delay: 0s;
    }

    &:nth-of-type(2)::before {
      animation-delay: 0.2s;
      background-color: ${color.secondary.regular};
    }

    &:nth-of-type(2)::after {
      animation-delay: 0.2s;
      background-color: ${color.secondary.regular};
      border: 1px solid ${color.secondary.regular};
    }

    &:nth-of-type(3)::before {
      animation-delay: 0.3s;
      background-color: ${color.tertiary.regular};
    }

    &:nth-of-type(3)::after {
      animation-delay: 0.3s;
      background-color: ${color.tertiary.regular};
      border: 1px solid ${color.tertiary.regular};
    }
  `;
});

const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 145px;
`;

const Loader = styled.div`
  flex-basis: 100%;
  max-width: 100%;
  min-height: 300px;
  max-height: 300px;
  height: 50vh;
  position: relative;
  overflow: hidden;
  z-index: 1;
  &::before,
  &::after {
    position: absolute;
    content: '';
    box-sizing: border-box;
  }
`;

const LoaderAnimation = () => {
  return (
    <Flex>
      <Loader>
        <LoaderContainer>
          <BallWrapper></BallWrapper>
          <BallWrapper></BallWrapper>
          <BallWrapper></BallWrapper>
        </LoaderContainer>
      </Loader>
    </Flex>
  );
};

export default LoaderAnimation;
